export const compactView = "@media screen and (max-width: 700px)";
